export enum PluginTypes {
  Como = 'como',
  Zerosix = 'zerosix',
  Pongo = 'pongo',
  ResaNinja = 'resa-ninja',
}
